export {
    EXTENDED_PARAMETERS_SERVICE_NAME,
    EXTENDED_PARAMETERS_SERVICE_PROVIDER_NAME,
    ExtendedParametersService,
    ExtendedParametersServiceProvider
} from './extended-parameters.service'

export { EXTENDED_PARAMETERS_SERVICES_MODULE_NAME } from './extended-parameters.services.module'
